import {
  Empleo,
  Empresa,
  OfertaSection,
  ServiceItem,
} from "../types/landingSections";

export interface LandingSectionData {
  id?: string;
  position?: number;
  visible?: boolean;

  props?: {
    title?: string;
    subtitle?: string;
    items?: ServiceItem[];
  };
}

export interface LandingData {
  theme: {
    backgroundType: "image" | "color";
    backgroundImage?: string;
    backgroundColor?: string;
    overlayOpacity?: number;

    globalStyles: {
      fontFamily?: string;

      h1Color?: string;
      h2Color?: string;
      h3Color?: string;
      textColor?: string;

      buttonColor?: string;
      buttonTextColor?: string;

      accentColor?: string;
    };

    components: {
      contact?: {
        titleColor: string;
        textColor: string;
        fontFamily: string;
      };
      hero?: {
        titleColor: string;
        textColor: string;
        fontFamily: string;
      };
      services?: {
        titleColor: string;
        textColor: string;
        fontFamily: string;
      };
    };
  };

  // ✅ NUEVA ESTRUCTURA BACKEND
  hero?: LandingSectionData;
  services?: LandingSectionData;
  contactSection?: LandingSectionData;
  footer?: LandingSectionData;

  home: {
    hero: {
      title: string;
      subtitle: string;
      badge: string;
      image?: string;
    };

    stats: {
      clients: string;
      years: string;
      support: string;
    };

    empleos: Empleo[];

    ofertas: {
      sections: OfertaSection[];
    };

    services: {
      title: string;
      subtitle: string;
      items: ServiceItem[];
    };
  };

  contact: {
    perfil_profesional_id?: number;
    id?: string | number;

    title: string;
    subtitle?: string;

    correo_perfil?: string;
    phone?: string;
    website?: string;
    whatsapp?: string;

    social?: {
      platform: string;
      url: string;
    }[];
  };

  company: {
    id: number;
    name: string;
    description?: string;
  };

  whoWeAre: {
    title: string;
    description: string;

    mission: string;
    vision: string;
    values: string[];

    extraTitle: string;
    extraDescription: string;
    extraPoints: string[];

    faqTitle: string;
    faq: {
      question: string;
      answer: string;
    }[];

    sliderImages: string[];

    team: {
      nombre: string;
      cargo: string;
      foto: string;
    }[];

    closingText: string;
  };
}


/**
 * 🔥 NORMALIZADOR (CLAVE PARA EVITAR ERRORES EN BLANCO)
 */
export const normalizeLandingData = (
  data?: Partial<LandingData>,
): LandingData => {
  return {
    theme: {
      backgroundType: data?.theme?.backgroundType ?? "image",

      backgroundImage:
        data?.theme?.backgroundImage ?? "/img/landing/fondoLanding.jpeg",

      backgroundColor: data?.theme?.backgroundColor ?? "#000000",

      overlayOpacity: data?.theme?.overlayOpacity ?? 0.6,

      globalStyles: {
        fontFamily: data?.theme?.globalStyles?.fontFamily ?? "Inter",

        h1Color: data?.theme?.globalStyles?.h1Color ?? "#ffffff",

        h2Color: data?.theme?.globalStyles?.h2Color ?? "#e5e5e5",

        h3Color: data?.theme?.globalStyles?.h3Color ?? "#d4d4d4",

        textColor: data?.theme?.globalStyles?.textColor ?? "#a1a1aa",

        buttonColor: data?.theme?.globalStyles?.buttonColor ?? "#00f4fb",
        buttonTextColor:
          data?.theme?.globalStyles?.buttonTextColor ?? "#000000",

        accentColor: data?.theme?.globalStyles?.accentColor ?? "#00f4fb",
      },

      components: {
        contact: {
          titleColor: data?.theme?.components?.contact?.titleColor ?? "#ffffff",

          textColor: data?.theme?.components?.contact?.textColor ?? "#a1a1aa",

          fontFamily: data?.theme?.components?.contact?.fontFamily ?? "Inter",
        },

        hero: {
          titleColor: data?.theme?.components?.hero?.titleColor ?? "#ffffff",

          textColor: data?.theme?.components?.hero?.textColor ?? "#a1a1aa",

          fontFamily: data?.theme?.components?.hero?.fontFamily ?? "Inter",
        },

        services: {
          titleColor:
            data?.theme?.components?.services?.titleColor ?? "#ffffff",

          textColor: data?.theme?.components?.services?.textColor ?? "#a1a1aa",

          fontFamily: data?.theme?.components?.services?.fontFamily ?? "Inter",
        },
      },
    },

    company: {
      id: data?.company?.id ?? 0,
      name: data?.company?.name ?? "Profesional",
      description: data?.company?.description ?? "",
    },

    home: {
      hero: {
        title: data?.home?.hero?.title ?? "",

        subtitle: data?.home?.hero?.subtitle ?? "",

        badge: data?.home?.hero?.badge ?? "",

        image: data?.home?.hero?.image ?? "",
      },

      stats: {
        clients: data?.home?.stats?.clients ?? "+0",

        years: data?.home?.stats?.years ?? "0",

        support: data?.home?.stats?.support ?? "24/7",
      },

      empleos: data?.home?.empleos ?? [],

      ofertas: {
        sections: data?.home?.ofertas?.sections ?? [
          {
            id: crypto.randomUUID(),
            layout: "carousel",
            title: "Servicios destacados",
            maxVisible: 6,
            ofertas: [],
          },
        ],
      },

      services: {
        title: data?.home?.services?.title ?? "Servicios",

        subtitle:
          data?.home?.services?.subtitle ??
          "Soluciones diseñadas para ofrecer resultados reales",

        items: data?.home?.services?.items ?? [],
      },
    },

    contact: {
      perfil_profesional_id: data?.contact?.perfil_profesional_id,

      id: data?.contact?.id,

      title: data?.contact?.title ?? "Contacto",

      correo_perfil:
        data?.contact?.correo_perfil ??
        (data?.contact as any)?.email ??
        "",

      phone: data?.contact?.phone ?? "",

      website: data?.contact?.website ?? "",

      social: data?.contact?.social ?? [],

      whatsapp: data?.contact?.whatsapp ?? "",
    },

    whoWeAre: {
      title: data?.whoWeAre?.title ?? "Quiénes somos",

      description: data?.whoWeAre?.description ?? "",

      mission: data?.whoWeAre?.mission ?? "",

      vision: data?.whoWeAre?.vision ?? "",

      values: data?.whoWeAre?.values ?? [
        "Profesionalidad",
        "Transparencia",
        "Compromiso",
        "Innovación",
      ],

      extraTitle:
        data?.whoWeAre?.extraTitle ?? "¿Por qué trabajar con nosotros?",

      extraDescription:
        data?.whoWeAre?.extraDescription ??
        "Acompañamos a nuestros clientes en cada etapa del proceso.",

      extraPoints: data?.whoWeAre?.extraPoints ?? [
        "Años de experiencia en el sector.",
        "Equipo multidisciplinar especializado.",
        "Metodología clara y transparente.",
        "Acompañamiento continuo.",
      ],

      faqTitle: data?.whoWeAre?.faqTitle ?? "Preguntas frecuentes",

      faq: data?.whoWeAre?.faq ?? [
        {
          question: "¿Con qué tipo de clientes trabajáis?",
          answer: "Con empresas de todos los tamaños.",
        },
        {
          question: "¿Cómo empezamos a trabajar juntos?",
          answer: "Con una reunión inicial para entender tus necesidades.",
        },
      ],

      sliderImages: data?.whoWeAre?.sliderImages ?? ["/icons/cuadranex.png"],

      team: data?.whoWeAre?.team ?? [
        {
          nombre: "Nombre del profesional",
          cargo: "Cargo o puesto",
          foto: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
        },
      ],

      closingText:
        data?.whoWeAre?.closingText ??
        "Creemos en relaciones duraderas basadas en la confianza y la calidad del servicio.",
    },
  };
};

/**
 * 🧱 BUILD ORIGINAL (con seguridad añadida)
 */
export const buildLandingData = (empresa: Empresa): LandingData => {
  const name =
    empresa.nombre_comercial?.trim() || empresa.nombre_empresa || "Profesional";

  return normalizeLandingData({
    theme: {
      backgroundType: "image",

      backgroundImage: "/img/landing/LogoLinkServs.png",

      backgroundColor: "#000000",

      overlayOpacity: 0.6,

      globalStyles: {
        fontFamily: "Inter",

        // Colores
        h1Color: "#ffffff",
        h2Color: "#f3f4f6",
        h3Color: "#d4d4d8",
        textColor: "#a1a1aa",

        // Colores de la marca
        buttonColor: "#00f4fb",
        buttonTextColor: "#000000",

        accentColor: "#00f4fb",
      },

      components: {
        contact: {
          titleColor: "#ffffff",
          textColor: "#a1a1aa",
          fontFamily: "Inter",
        },

        hero: {
          titleColor: "#ffffff",
          textColor: "#a1a1aa",
          fontFamily: "Inter",
        },

        services: {
          titleColor: "#ffffff",
          textColor: "#a1a1aa",
          fontFamily: "Inter",
        },
      },
    },

    company: {
      id: empresa.perfil_profesional_id,
      name,
      description: empresa.descripcion,
    },

    home: {
      hero: {
        title: name,
        subtitle:
          empresa.descripcion ||
          "Ofrecemos soluciones profesionales adaptadas a cada cliente.",
        badge: "✨ Servicio profesional verificado",
      },

      stats: {
        clients: "+500",
        years: "10+",
        support: "24/7",
      },

      empleos: [],

      ofertas: {
        sections: [
          {
            id: crypto.randomUUID(),

            layout: "carousel",

            title: "Servicios destacados",

            maxVisible: 6,

            ofertas: empresa.ofertas ?? [],
          },
        ],
      },

      services: {
        title: "Servicios",
        subtitle: "Soluciones diseñadas para ofrecer resultados reales",
        items: [],
      },
    },

    contact: {
      perfil_profesional_id: empresa.perfil_profesional_id,
      title: "Contacto",
      correo_perfil: empresa.correo_perfil,
      phone: empresa.numero_telefono,
      website: empresa.url_web,
      social: [],
      whatsapp: empresa.numero_telefono,
    },

    whoWeAre: {
      title: "Quiénes somos",

      description:
        empresa.descripcion ||
        "Somos un equipo de profesionales comprometidos con ofrecer soluciones de calidad adaptadas a cada cliente.",

      mission:
        "Ofrecer servicios profesionales de alta calidad, combinando experiencia, innovación y cercanía con el cliente.",

      vision:
        "Ser una empresa referente en el sector, destacando por la excelencia, confianza y resultados.",

      values: ["Profesionalidad", "Transparencia", "Compromiso", "Innovación"],

      extraTitle: "¿Por qué trabajar con nosotros?",

      extraDescription:
        "Acompañamos a nuestros clientes en cada etapa del proceso.",

      extraPoints: [
        "Años de experiencia en el sector.",
        "Equipo multidisciplinar especializado.",
        "Metodología clara y transparente.",
        "Acompañamiento continuo.",
      ],

      faqTitle: "Preguntas frecuentes",

      faq: [
        {
          question: "¿Con qué tipo de clientes trabajáis?",
          answer: "Con empresas de todos los tamaños.",
        },
        {
          question: "¿Cómo empezamos a trabajar juntos?",
          answer: "Con una reunión inicial para entender tus necesidades.",
        },
      ],

      sliderImages: ["/icons/cuadranex.png"],

      team: [
        {
          nombre: name,
          cargo: "Profesional",
          foto: "/img/default-avatar.png",
        },
      ],

      closingText:
        "Creemos en relaciones duraderas basadas en la confianza y la calidad del servicio.",
    },
  });
};
